import state from "./state.js";
import actions from "./actions.js";
import reducer from "./reducer.js";
import createContext from "../createContext.js";
import { useContext } from "react";

const {
  Context: cartesianContext,
  Provider: CartesianProvider,
  actions: processedActions,
} = createContext(state, actions, reducer);

export const useCartesianContext = () => {
  return useContext(cartesianContext);
};

export const useCartesianActions = () => {
  return processedActions();
};

export default CartesianProvider;
